const PlayMark = () => (
  <svg viewBox="0 0 512 512" className="h-7 w-7" aria-hidden="true">
    <path fill="#EA4335" d="M325.3 234.3 104.6 13l280.8 161.2z" />
    <path fill="#FBBC04" d="M47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256z" />
    <path fill="#4285F4" d="M104.6 499l280.8-161.2-60.1-60.1z" />
    <path fill="#34A853" d="M385.4 337.8l60.1-60.1c21.6-12.2 21.6-31.2 0-43.4l-60.1-60.1-60.1 60.1z" />
  </svg>
);

export const GooglePlayBadge = ({ testId = "google-play-badge", className = "" }) => (
  <a
    href="#"
    data-testid={testId}
    aria-label="Get it on Google Play – link coming soon"
    className={`inline-flex items-center gap-3 rounded-[20px] border-2 border-[#1A1D1E] bg-[#1A1D1E] px-6 py-3 shadow-[0_5px_0_0_rgba(26,29,30,0.35)] transition-[transform,box-shadow] duration-150 hover:translate-y-[2px] hover:shadow-[0_3px_0_0_rgba(26,29,30,0.35)] active:translate-y-[5px] active:shadow-none focus:outline-none focus-visible:ring-4 focus-visible:ring-[#FFC837]/60 ${className}`}
  >
    <PlayMark />
    <span className="text-left leading-tight">
      <span className="block text-[11px] font-bold uppercase tracking-[0.18em] text-white/60">
        Get it on
      </span>
      <span className="block font-display text-xl font-semibold text-white">
        Google Play
      </span>
    </span>
  </a>
);
